module.exports = __webpack_public_path__ + "static/Softball-Building-Render-800x500-d03f114c901c8129288352fdb871ee3c.jpg";